<div class="popup modal-header d-inline-block  pb-0 w-100 m-auto">

  <div class="" *ngIf="step1">
    <div class="pop-up-header p-4 border-bottom d-flex justify-content-between w-100" >
      <h2>Invite User(s)</h2>
      <fa-icon [icon]="icons.cancel" (click)="bsModalRef?.hide()" class="icon"></fa-icon>
    </div>
    <form class="p-4" >
     <div class="form-input mb-5">
      <label>Email address</label>
      <!-- <div class="form-input ">
          <input  type="email" placeholder="@ Email Address" name="email" >
          <select name ="role">
            <option>Select role</option>
            <option value="admin">Admin </option>
            <option value="member">Member </option>
            <option value="member">Owner </option>
          </select>
      </div> -->
      <form [formGroup]="inviteForm" class="d-flex">
        <div class="flex-1">
          <app-input formCtrlName="email" [className]="'email-invite-input'" type="email" [formGrp]="inviteForm"
            email></app-input>
        </div>
        <select placeholder='Select role' formControlName="role"
          class="form-control text-capitalize email-role-input me-2" required>
          <option value="" >Select role</option>
          <option *ngFor="let type of roles" [value]="type">{{type}}</option>
        </select>
        <app-button [disabled]="!inviteForm.valid" primary class="mt-1" (onclick)="addEmployee()">Add</app-button>
      </form>

      <div class="">
        <span class="employee-badge me-4 mt-2" *ngFor="let employee of employees; let i=index;">
          <span class="initials">
            {{employee.email.substring(0,1).toUpperCase()}}
          </span>
          <ng-container *ngIf="employee.email.split('@').length > 1">
            {{employee.email.split("@")[0] }}
          </ng-container>

          <ng-container>
            ({{employee.role}})
          </ng-container>
          <span class="cur-pnt ms-2" (click)="removeEmployee(i)">
            <fa-icon class="icon-prefix" [icon]="icons.close"></fa-icon>
          </span>
        </span>
      </div>

     </div>
     <div class="form-group message" [formGroup]="form">
      <label>Message <span>(optional)</span></label>
      <textarea formControlName="message" name="message" class="p-3 text-black" placeholder="Matt is Inviting you to Clooper’s corporate account"></textarea>
     </div>

    </form>
    <div class="footer">
      <button class="btn btn-cancel " (click)="bsModalRef?.hide()">Cancel</button>
      <button class="btn " [disabled]="employees.length === 0 || loading" (click)="addAddedEmployee()">
        {{ loading ? 'Sending...' : 'Send Invite' }}
      </button>
    </div>
  </div>

  <div class="p-4 " *ngIf="!step1">
    <div class="text-right w-100" ><fa-icon [icon]="icons.cancel" (click)="bsModalRef?.hide()"    class="icon"></fa-icon></div>
    <div class="d-flex justify-content-center align-items-center">
      <img src="assets/images/Success.gif" class="success">
    </div>
    <h1 class="text-center">Invite Sent!</h1>
    <p class="mb-5 text-center">Your invite has been sent to your employee.
    </p>
    <div class="mb-4 d-flex  gap-3 resend">
      <button class="btn btn-resend w-100 " (click)="close()">Done</button>
    </div>
  </div>
</div>


